import { render, staticRenderFns } from "./CancellationTermsModal.vue?vue&type=template&id=5b861ea4&scoped=true"
import script from "./CancellationTermsModal.vue?vue&type=script&lang=js"
export * from "./CancellationTermsModal.vue?vue&type=script&lang=js"
import style0 from "./CancellationTermsModal.vue?vue&type=style&index=0&id=5b861ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b861ea4",
  null
  
)

export default component.exports